import { render } from "./ProductsList.vue?vue&type=template&id=77d1e31f&ts=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=77d1e31f&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__